export var componentsLocales = {
  enterValue: 'Start typing',
  notFound: 'Nothing was found',
  updateValue: 'Start typing or changing the value'
};